export function removeWhitespaceAndNewlines(input?: string): string {
	if (!input) return '';
	return input.replace(/\s+/g, ' ').trim();
}

export function buildDisplayName(firstName?: string, lastName?: string): string {
	if (!firstName && !lastName) return '';
	if (!firstName) return removeWhitespaceAndNewlines(lastName);
	if (!lastName) return removeWhitespaceAndNewlines(firstName);
	return removeWhitespaceAndNewlines(`${lastName}, ${firstName}`);
}

export function normalizeBoolean(value: unknown): boolean {
	if (typeof value === 'boolean') return value;
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		if (normalized === 'true' || normalized === '1') return true;
		if (normalized === 'false' || normalized === '0' || normalized === '') return false;
	}
	if (typeof value === 'number') return value === 1;
	return Boolean(value);
}

export function toNullableNumber(value: unknown): number | null {
	if (value == null || value === '') return null;
	if (typeof value === 'number' && Number.isFinite(value)) return value;
	if (typeof value === 'string') {
		const parsed = Number(value);
		if (Number.isFinite(parsed)) return parsed;
	}
	return null;
}
